"use client";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SizeBorderWidthThin, ColorGray500, SpaceMd, SpaceXs, ColorGray200, ColorGray900 } from "@nxt-costco-com/forge-design-tokens";
import { ChevronDown } from "@nxt-costco-com/forge-icons";
const StyledAccordion = styled(Accordion, {
  shouldForwardProp: (prop) => prop !== "sx"
})({
  alignItems: "flex-start",
  borderRadius: 0,
  display: "flex",
  flexDirection: "column",
  boxShadow: "none",
  "&.MuiPaper-root": {
    backgroundColor: "inherit",
    "> .MuiAccordion-heading": { width: "100%" },
    "&.MuiAccordion-root": {
      borderRadius: 0,
      borderTop: `${SizeBorderWidthThin} solid ${ColorGray500}`,
      margin: 0,
      "::before": {
        backgroundColor: "transparent"
      },
      "&:last-of-type": {
        borderBottom: `${SizeBorderWidthThin} solid ${ColorGray500}`
      },
      "&:only-of-type": {
        borderTop: `${SizeBorderWidthThin} solid ${ColorGray500}`,
        borderBottom: `${SizeBorderWidthThin} solid ${ColorGray500}`
      },
      "&.Mui-expanded": {
        marginBottom: 0
      }
    },
    "> .MuiCollapse-root": {
      width: "100%"
    }
  }
});
const StyledAccordionSummary = styled(AccordionSummary)`
    height: auto;
    width: 100%;
    padding: 0;
    &.MuiButtonBase-root {
        &.MuiAccordionSummary-root {
            align-items: flex-start;
            align-self: stretch;
            padding: ${SpaceMd};
            gap: ${SpaceXs};
            text-align: left;
            &.Mui-focusVisible {
                background-color: ${ColorGray200};
                outline-offset: 2px;
                outline: 2px solid Highlight;
                outline: 2px solid -webkit-focus-ring-color;
            }
            :hover {
                background-color: ${ColorGray200};
            }
            & > .MuiAccordionSummary-content {
                margin: 0;
                gap: ${SpaceXs};
            }
            & > .MuiAccordionSummary-expandIconWrapper {
                align-self: center;
            }
        }
        ,
        &.Mui-expanded {
            min-height: 0;
        }
    }
`;
const StyledAccordionDetails = styled(AccordionDetails)({
  padding: `${SpaceXs} ${SpaceMd} ${SpaceMd}`
});
const StyledChevron = styled(ChevronDown)({
  color: ColorGray900,
  height: `20px`,
  width: `20px`
});
export {
  StyledAccordion,
  StyledAccordionDetails,
  StyledAccordionSummary,
  StyledChevron
};
